// =============================================================================
// STATS SECTION COMPONENT
// =============================================================================

import React from 'react';
import type { ContentComponent } from '@/types';

interface StatsSectionProps {
  component: ContentComponent;
}

/**
 * Stats Section Component
 */
export const StatsSection: React.FC<StatsSectionProps> = ({ component }) => {
  return <StatsSectionImpl component={component} />;
};

/**
 * Stats Section Implementation
 */
const StatsSectionImpl: React.FC<{ component: ContentComponent }> = ({ component }) => {
  const { id, title, content, metadata } = component;
  
  const stats = metadata?.stats || [];
  const columns = metadata?.columns || 4;
  
  return (
    <section id={id} className="content-section stats-section">
      <div className="container">
        {title && (
          <div className="section-header">
            <h2>{title}</h2>
            {content && <p>{content}</p>}
          </div>
        )}
        
        <div className={`grid grid-cols-${columns}`}>
          {stats.map((stat: any, index: number) => (
            <div key={index} className="stat-item">
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
              {stat.description && (
                <div className="stat-description">{stat.description}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export { StatsSectionImpl };

